export default function (app) {
  const url2vanity = {};
  const vanity2url = {};

  app.getUrl2Vanity = (url) => url2vanity[url] || url;
  app.getVanity2Url = (url) => vanity2url[url] || url;

  const init = async ({ contentType, format, field = "vanityUrl" }) => {
    const base = `/${contentType}/${format}/`;

    const setUrls = async () => {
      const { data } = await app.database[contentType].search({});
      if (!data) return;

      for (const url of Object.keys(url2vanity).filter((url) => url.startsWith(base))) {
        delete vanity2url[url2vanity[url]];
        delete url2vanity[url];
      }

      data.forEach(({ _id, [field]: vanityUrl, hidden }) => {
        if (!vanityUrl || hidden) return;
        if (vanityUrl[0] !== "/") vanityUrl = `/${vanityUrl}`;

        url2vanity[`${base}${_id}`] = vanityUrl;
        vanity2url[vanityUrl] = `${base}${_id}`;
      });

      app.event("vanityUrlLoad");
    };

    app.database[contentType].on("update", setUrls);
    app.on(["login", "logout"], setUrls);
    await setUrls();
  };

  if (app.settings.vanityUrls)
    app.on("init", -100, async () => {
      window.document.title = app.settings.name;
      await Promise.all(app.settings.vanityUrls.map(init));
    });
}
